import { render, staticRenderFns } from "./AddVenueListItem.vue?vue&type=template&id=31855844&scoped=true&"
import script from "./AddVenueListItem.vue?vue&type=script&lang=ts&"
export * from "./AddVenueListItem.vue?vue&type=script&lang=ts&"
import style0 from "./AddVenueListItem.vue?vue&type=style&index=0&id=31855844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31855844",
  null
  
)

export default component.exports